import React, { useState, useEffect } from 'react';
import { useFetchData, useUpdateData } from 'services/queries';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TaxConfigurationTab from './components/TaxConfigurationTab';
import TusRatesTab from './components/TusRatesTab';

const TaxSettings = () => {
    const { data: taxConfig, isLoading: isLoadingConfig, refetch: refetchConfig } = useFetchData('tax/tax-configuration', true);
    const { data: tusRates, isLoading: isLoadingTUS, refetch: refetchTUS } = useFetchData('tax/tus-rates', true);

    const [configFormData, setConfigFormData] = useState({});
    const [tusRatesData, setTusRatesData] = useState([]);
    const [activeTab, setActiveTab] = useState('1');

    const updateConfig = useUpdateData('tax/tax-configuration');

    useEffect(() => {
        if (taxConfig) {
            setConfigFormData({
                aliquota_seg_int: taxConfig.aliquota_seg_int,
                pis_cofins_taxa: taxConfig.pis_cofins_taxa,
                credit_pis_pasep_rate: taxConfig.credit_pis_pasep_rate,
                credit_cofins_rate: taxConfig.credit_cofins_rate
            });
        }
    }, [taxConfig]);

    useEffect(() => {
        if (tusRates) {
            setTusRatesData(tusRates.map(rate => ({
                id: rate.id,
                additions: rate.additions,
                value: rate.value
            })));
        }
    }, [tusRates]);

    const handleConfigInputChange = (e) => {
        const { id, value } = e.target;
        setConfigFormData(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSaveConfig = () => {
        const { id, ...configData } = configFormData;
        updateConfig.mutate({
            id: id,
            newData: configData
        }, {
            onSuccess: () => {
                refetchConfig();
            }
        });
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    if (isLoadingConfig || isLoadingTUS) {
        return <div>Loading...</div>;
    }

    return (
        <Box p={3}>
            <TabContext value={activeTab}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleTabChange} aria-label="tax settings tabs">
                        <Tab label="Tax Configuration" value="1" />
                        <Tab label="TUS Rates" value="2" />
                    </TabList>
                </Box>
                <TabPanel value="1">
                    <TaxConfigurationTab
                        configFormData={configFormData}
                        handleConfigInputChange={handleConfigInputChange}
                        handleSaveConfig={handleSaveConfig}
                        updateConfig={updateConfig}
                    />
                </TabPanel>
                <TabPanel value="2">
                    <TusRatesTab
                        tableData={tusRatesData}
                        setTableData={setTusRatesData}
                    />
                </TabPanel>
            </TabContext>
        </Box>
    );
};

export default TaxSettings;